<template>
  <div class="sticky-quote-wrapper">
    <button
      @click="modalOpen"
      :class="stickyButtonClass"
      type="button"
      :aria-pressed="modalQuoteVisible"
      aria-haspopup="dialog"
      :tabindex="quoteButton && !isScrolledToBottom ? 0 : -1"
      :aria-label="siteSettingsStore.formType === 'offer' ? $t('Start Project') : $t('Make An Appointment')"
      class="fixed right-0 bottom-[calc(50%+60px)] bg-brand-second cursor-pointer flex justify-center items-center z-20 py-3 lg:py-4 px-2 lg:px-3 [writing-mode:vertical-rl] tracking-wider transition-all duration-500 ease-in-out shadow-md"
    >
      <span
        class="text-white text-base lg:text-lg font-medium font-saira uppercase"
      >
        {{
          siteSettingsStore.formType === "offer"
            ? $t("Start Project")
            : $t("Make An Appointment")
        }}
      </span>
    </button>

    <component
      :is="siteSettingsStore.formType === 'offer' ? QuoteModal : AppointmentModal"
      v-if="quoteModalMounted"
      :visible="modalQuoteVisible"
      @update:visible="modalQuoteVisible = $event"
    />
  </div>
</template>
<script setup>
import { defineAsyncComponent } from "vue";
import { useModalStore, useSiteSettingsStore } from "@/store/index";
const props = defineProps({
  enabled: { type: Boolean },
});

const useModal = useModalStore();
const quoteButton = ref(false);
const modalQuoteVisible = ref(false);
const { mounted: quoteModalMounted } = useLazyMount(modalQuoteVisible, 250);
const QuoteModal = defineAsyncComponent(() =>
  import("~/components/Plugins/Modal/Quote.vue")
);
const AppointmentModal = defineAsyncComponent(() =>
  import("~/components/Plugins/Modal/Appointment.vue")
);
const isScrolledToBottom = ref(false);
let idleTimeoutId = null;

function modalOpen() {
  modalQuoteVisible.value = true;
}

function showButton() {
  quoteButton.value = true;
}

function handleScroll() {
  const scrollY = window.scrollY;
  const scrollPosition = window.innerHeight + window.scrollY;
  const bottomPosition = document.body.offsetHeight;

  // Hide while scrolling; show again after scrolling stops
  quoteButton.value = false;

  if (idleTimeoutId) {
    clearTimeout(idleTimeoutId);
    idleTimeoutId = null;
  }

  if (scrollY > 200) {
    idleTimeoutId = setTimeout(() => {
      showButton();
    }, 500);
  }

  isScrolledToBottom.value = scrollPosition > bottomPosition;
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  if (idleTimeoutId) {
    clearTimeout(idleTimeoutId);
    idleTimeoutId = null;
  }
});

watch(
  () => useModal.isQuoteModal,
  (shouldOpen) => {
    if (shouldOpen) {
      modalQuoteVisible.value = true;
      useModal.resetModal();
    }
  }
);
const siteSettingsStore = useSiteSettingsStore();
const stickyButtonClass = computed(() => [
  { 'rounded-tl-lg rounded-bl-lg': siteSettingsStore.roundCorner },
  { 'lg:opacity-0 lg:invisible lg:translate-x-full': isScrolledToBottom.value },
  quoteButton.value
    ? 'translate-x-0 opacity-100 pointer-events-auto'
    : 'translate-x-full opacity-0 pointer-events-none',
]);
</script>
